import 'css-chunksrc/client/scenes/planzoneResourceToProject/resourceToProjectForm/styles.scss';export default {
  "resourceToProjectForm": "_resourceToProjectForm_1lfij_1",
  "description": "_description_1lfij_7",
  "secondInput": "_secondInput_1lfij_13"
};